import script from "./AlojamientoAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlojamientoAdminView.vue?vue&type=script&setup=true&lang=js"

import "./AlojamientoAdminView.vue?vue&type=style&index=0&id=0f7b8845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7b8845"]])

export default __exports__